import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import type { EchoDraftResponse } from '@/types/echo_creation';

interface DraftsStateProps {
  drafts: EchoDraftResponse[];
}

export const DraftsState: React.FC<DraftsStateProps> = ({ drafts }) => {
  const navigate = useNavigate();

  const handleResume = (draftId: string) => {
    navigate(`/create-echo?draftId=${draftId}`);
  };

  return (
    <div className='flex h-full flex-col items-start gap-6 p-10'>
      <PageHeader title='MY DRAFTS' titleClassName='text-brand-800' theme='dark' />
      <p className='text-gray-600'>
        You have pending drafts. Resume creation to publish your echo.
      </p>

      <div className='grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3'>
        {drafts.map((draft) => (
          <div key={draft.id} className='rounded-xl border border-gray-200 bg-white p-6 shadow-sm'>
            <h3 className='mb-2 text-xl font-bold text-brand-800'>
              {draft.name || 'Untitled Echo'}
            </h3>
            <p className='mb-4 text-sm text-gray-500'>Status: {draft.status}</p>
            <Button onClick={() => handleResume(draft.id)} variant='purple' className='w-full'>
              Resume
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
